import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { GroupedSchoolLocation } from '../../types';
import { SchoolLocation } from '@lx/quote-tool/lite/shared/types';
import { LocationSelectorComponent } from '../location-selector/location-selector.component';
import { SelectorFieldContainerComponent, SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-location-selector-field',
  templateUrl: './location-selector-field.component.html',
  styleUrls: ['./location-selector-field.component.scss'],
  imports: [LocationSelectorComponent, SidePanelComponent, SelectorFieldContainerComponent, CommonModule, SelectorFieldContainerComponent, SidePanelComponent],
})
export class LocationSelectorFieldComponent extends DialogBasedSelector<SchoolLocation> {
  @Input() groupedSchoolLocations: GroupedSchoolLocation[] | undefined;
}
